export default __webpack_public_path__ + "static/media/bihada-factory-mission-01.f2841ef3.jpg";